import { Group, Stack, Text } from '@inflearn/ds-react';

interface MoleGameStatsProps {
  timeLeft: number;
  score: number;
}

export const MoleGameStats = ({ timeLeft, score }: MoleGameStatsProps) => {
  return (
    <Group position="apart" align="center" spacing={16}>
      <Stack spacing={4} align="center">
        <Text size="sm" c="gray.6" fw={500}>
          시간
        </Text>
        <Text size="xl" fw={700}>
          {timeLeft}초
        </Text>
      </Stack>
      <Stack spacing={4} align="center">
        <Text size="sm" c="gray.6" fw={500}>
          점수
        </Text>
        <Text size="xl" fw={700}>
          {score}점
        </Text>
      </Stack>
    </Group>
  );
};
